import React, {useState} from "react";
import PageHeaderLayout from "../../layout/pageHeaderLayout";
import StandardTable, {StandardColumnsType} from "../../components/StandardTable";
import * as api from "../../apis/sysTodo";
import useAntTable from "../../utils/useAntTable";
import Moment from "moment";
import SysTodoDetail from "./detail";
import {Divider} from "antd";
import {useHistory} from "react-router-dom";
import {useRequest} from "ahooks";
import {todoSourceOptions, todoTypeOptions} from "../../utils/searchOptions";


const MessageTypeMap: { [key: string]: String } = {
    message: '消息',
    workflow: '工作流'
}

function SysTodo() {

    const history = useHistory()
    const {tableProps, refresh} = useAntTable(api.getTodos, {})
    const [selectedRecord, setSelectedRecord] = useState<any | undefined>()
    const {run: onRead} = useRequest(api.readMessage, {manual: true, onSuccess: () => refresh()})

    function onDetailClick(record: any) {
        if (record.type === 'message') {
            setSelectedRecord(record)
            return !record.read && onRead(0, record.id)
        } else if (record.type === 'workflow') {
            if (record.sourceCode === 'sale-service') {
                history.push('/sale/service/' + record.businessId)
            }
            return !record.read && onRead(1, record.id)
        }
    }

    function onContentClick(event: any, record: any) {
        if (event.target.tagName === 'A') {
            event.preventDefault()
            history.push(event.target.pathname)
        }
    }

    function renderRow(record: any, value: any) {
        return (
            <span style={{
                color: record.color || "#000000D9",
                fontWeight: record.read ? 'normal' : 'bold'
            }}>{value}</span>
        )
    }

    const columns: StandardColumnsType = [
        {
            title: '编号',
            dataIndex: 'no',
            render: (value: any, record: any) => renderRow(record, value),
            search: true
        },
        {
            title: '类型',
            dataIndex: 'type',
            render: (value: any, record: any) => renderRow(record, MessageTypeMap[value]),
            search: true,
            valueType: 'select',
            valueEnum: todoTypeOptions
        },
        {
            title: '来源',
            dataIndex: 'source',
            render: (value: any, record: any) => renderRow(record, value),
            search: true,
            valueType: 'select',
            valueEnum: todoSourceOptions
        },
        {
            title: '状态',
            dataIndex: 'read',
            render: (value: boolean, record: any) => renderRow(record, value ? '已读' : '未读')
        },
        {
            title: '消息',
            dataIndex: 'content',
            render: (value: any, record: any) => renderRow(record, (
                <span onClick={(event) => onContentClick(event, record)} dangerouslySetInnerHTML={{__html: value}}/>)),
        },
        {
            title: '创建时间',
            dataIndex: 'createTime',
            render: (value: any, record: any) => renderRow(record, Moment(value).format('lll'))
        },
        {
            title: '操作',
            dataIndex: 'operations',
            render: (_: any, record: any) => (
                <span>
                    <a onClick={() => onDetailClick(record)}>明细</a>
                    <Divider type={"vertical"}/>
                </span>
            )
        }
    ]

    return (
        <PageHeaderLayout>
            <StandardTable rowKey={'id'} columns={columns} {...tableProps} />
            <SysTodoDetail record={selectedRecord} visible={selectedRecord}
                           onCancel={() => setSelectedRecord(undefined)}/>
        </PageHeaderLayout>
    )
}

export default SysTodo